// Migrated 1:1 from @nexato/nx-core-module (components/billing-payment-method-view, #685)
import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { take } from 'rxjs/operators';
import { PaymentSubscription } from '../../entities/payment/payment';
import { PaymentMethod } from '../../entities/paymentMethod/tenantLicenceRequest';
import { UsersService } from '../../services/users/users.service';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-billing-payment-method-view',
  templateUrl: './billing-payment-method-view.component.html',
  styleUrls: ['./billing-payment-method-view.component.scss']
})
export class BillingPaymentMethodViewComponent implements OnInit {

  paymentMethod: PaymentMethod;
  public PaymentSubscription = PaymentSubscription;

  constructor(
    private apollo: Apollo,
    private userSerivce: UsersService
  ) {
  }

  ngOnInit(): void {
    this.subscribeToPaymentMethodData();
  }

  editPaymentMethod(paymentMethod: PaymentMethod) {
    console.log('edit payment method');
    window.location.href = paymentMethod?.updateLink;
  }

  subscribeToPaymentMethodData() {
    this.apollo.query<fromGraphQl.PaymentMethodQueryResponse>({
      fetchPolicy: 'network-only',
      query: fromGraphQl.PAYMENT_METHOD_QUERY,
      variables: {
        tenantId: this.userSerivce.getCurrentTenantId(),
      },
    }).pipe(
      take(1)
    ).subscribe( (data) => {
      this.paymentMethod = new PaymentMethod(data?.data?.paymentMethod);
    });
  }


}
